import { SvgProps } from "./Form";

export const PlayIconOutline = (props: SvgProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_12021_244)">
        <path
          d="M15.1765 8.30463L5.31982 2.01196V18.012L15.1725 11.6966C15.4593 11.5164 15.6957 11.2664 15.8597 10.97C16.0238 10.6736 16.11 10.3405 16.1104 10.0017C16.1108 9.66299 16.0253 9.32967 15.862 9.03289C15.6987 8.73612 15.4629 8.48557 15.1765 8.30463V8.30463ZM14.4565 10.568L6.65649 15.568V4.45063L14.4612 9.4333C14.5574 9.49348 14.6367 9.57724 14.6915 9.67663C14.7463 9.77602 14.7748 9.88776 14.7743 10.0013C14.7738 10.1148 14.7444 10.2263 14.6888 10.3252C14.6332 10.4241 14.5532 10.5072 14.4565 10.5666V10.568Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_12021_244">
          <rect
            width="16"
            height="16"
            fill="currentColor"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
